PJQ.views.files.FileNavigator = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'File-Navigator'),
        subTemplates: {
            file: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'File'),
            fileMenu: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'File-Menu')
        },
        isDeferred: true,
        sortBy: 'name',
        sortDirection: 'asc',
        expandAllFolders: false,
        expandSharedFolders: false,
        foldersOnly: false
    },
    defaultEvents: {
        'click .btn-add-root-folder': 'addRootFolderClicked',
        'click .attachment-link': 'attachmentLinkClicked',
        'click .attachment': 'attachmentClicked',
        'dblclick .attachment': 'attachmentDblClicked',
        'click .input-select-attachment': 'stopPropagation',
        'change .input-select-attachment': 'attachmentChecked',
        'click .btn-share-selected': 'shareSelected',
        'click .btn-download-selected': 'downloadSelected',
        'click .btn-cut-selected': 'cutSelected',
        'click .btn-copy-selected': 'copySelected',
        'click .btn-delete-selected': 'deleteSelected',
        'click .btn-order-selected': 'orderSelected',
        'click .btn-new-folder': 'addFolderClicked',
        'click .btn-export-file-list': 'exportFileListClicked',
        'click .btn-upload-attachments-root': 'uploadRootAttachmentsClicked',
        'click .btn-upload-attachments': 'uploadToFolderClicked',
        'click .btn-download-attachment': 'downloadAttachmentClicked',
        'click .btn-share-attachment': 'shareAttachmentClicked',
        'click .btn-order-attachment': 'orderAttachmentClicked',
        'click .btn-cut-attachment': 'cutAttachmentClicked',
        'click .btn-copy-attachment': 'copyAttachmentClicked',
        'click .btn-rename-attachment': 'renameAttachmentClicked',
        'click .btn-paste': 'pasteClicked',
        'click .btn-delete-attachment': 'deleteAttachmentClicked',
        'click .btn-attachment-properties': 'attachmentPropertiesClicked',
        'dragenter .attachment': 'attachmentDragEnter',
        'dragleave .attachment': 'attachmentDragLeave',
        'dragstart .attachment': 'attachmentDragStart',
        'dragover .attachment': 'attachmentDragOver',
        'drop .attachment': 'attachmentDrop',
        'click .btn-file-menu': 'renderContextMenu',
        'click .col-label': 'changeSort'
    },
    beforeInit: function () {
        this.expandedFolders = [];
        this.selectedAttachmentIds = [];
        this.highlightedAttachmentIds = [];
    },
    beforeFirstRender: function () {
        this.options.canAdd = PJQ.app.session.hasPermission('documents.canAdd');
        this.options.canShare = PJQ.app.session.hasPermission('documents.canShare') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SHARE_PEI);
        this.options.isAdmin = PJQ.app.session.hasPermission('documents.isAdmin');
        this.fetchAttachments();
    },
    getMenuActions: function () {
        let self = this;
        return [
            {
                name: 'New Folder',
                onClick: function (attachment) {
                    self.addFolder(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('isFolder');
                }
            },
            {
                name: 'Upload',
                onClick: function (attachment) {
                    self.uploadToFolder(attachment);
                },
                isShown: function (attachment) {
                    return self.options.canAdd && attachment.get('entryId') > 0 && attachment.get('isFolder');
                }
            },
            {
                name: 'Download',
                onClick: function (attachment) {
                    self.downloadAttachments(attachment);
                }
            },
            {
                name: 'View',
                onClick: function (attachment) {
                    new PJQ.views.files.FileViewer({
                        model: attachment
                    });
                },
                isShown: function (attachment) {
                    return attachment.get('name').toLowerCase().endsWith('.pdf');
                }
            },
            {
                name: 'Order',
                onClick: function (attachment) {
                    self.order(attachment);
                }
            },
            {
                name: 'Share',
                onClick: function (attachment) {
                    self.shareAttachments(attachment);
                },
                isShown: function () {
                    return self.options.canShare;
                }
            },
            {
                name: 'Export File List',
                onClick: function (attachment) {
                    self.exportFileList(attachment);
                },
                isShown: function (attachment) {
                    return attachment.get('entryId') > 0 && attachment.get('isFolder');
                }
            },
            {
                name: 'Cut',
                onClick: function (attachment) {
                    self.cutAttachments(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0;
                }
            },
            {
                name: 'Copy',
                onClick: function (attachment) {
                    self.copyAttachments(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0;
                }
            },
            {
                name: 'Paste',
                onClick: function (attachment) {
                    self.paste(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0
                        && attachment.get('isFolder') && self.clipboard != null;
                }
            },
            {
                name: 'Properties',
                onClick: function (attachment) {
                    self.attachmentProperties(attachment);
                },
                isShown: function (attachment) {
                    return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0;
                }
            },
            {
                name: 'Rename',
                onClick: function (attachment) {
                    self.renameAttachment(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0;
                }
            },
            {
                name: 'Delete',
                isDanger: true,
                onClick: function (attachment) {
                    self.deleteAttachments(attachment);
                },
                isShown: function (attachment) {
                    return self.options.isAdmin && attachment.get('entryId') > 0 && attachment.get('folderId') > 0;
                }
            }
        ];
    },
    isFetched: function () {
        return this.collection != null && this.collection.isFetched;
    },
    setAllExpanded: function () {
        _.each(this.collection.models, function (attachment) {
            if (this.expandedFolders.indexOf(attachment.cid) === -1 && attachment.get('isFolder') && ((!attachment.get('isDrawing') && attachment.getDepth() <= 1) || attachment.getDepth() <= 0)) {
                this.expandedFolders.push(attachment.cid);
            }
        }, this);
    },
    fetchAttachments: function (options = {isShared: true, isPrivate: true}) {
        if (this.options.project != null && this.options.forShare !== true) {
            this.options.project.fetchAttachments(options, _.bind(function (attachments) {
                this.options.isDeferred = attachments.options.isDeferred;
                if (this.options.isDeferred) {
                    this.$('.ct-selected-attachments').remove();
                }

                this.collection = attachments;
                if (this.options.expandAllFolders) {
                    this.setAllExpanded();
                } else if (this.options.expandSharedFolders) {
                    let sharedFolder = this.collection.findWhere({entryId: -1});
                    if (sharedFolder != null) {
                        this.expandedFolders.push(sharedFolder.cid);
                        this.expandedFolders.push(..._.map(sharedFolder.getFolderAttachments(), function (folder) {
                            return folder.cid;
                        }));
                    }
                }

                this.listenTo(this.collection, 'fetch update', this.renderAttachments);
                this.render();
            }, this));
        } else {
            if (this.collection == null) {
                this.collection = new PJQ.collections.files.Files();
                this.collection.fetch({
                    success: _.bind(function () {
                        if (this.options.expandAllFolders) {
                            this.setAllExpanded();
                        }
                        this.render();
                        this.listenTo(this.collection, 'fetch update', this.renderAttachments);
                    }, this)
                });
            } else {
                this.listenTo(this.collection, 'fetch update', this.renderAttachments);
                this.collection.isFetched = true;
                this.renderAttachments();
            }
        }
    },
    renderData: function () {
        return {
            collection: this.collection,
            canAdd: this.options.canAdd,
            canShare: this.options.canShare,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched(),
            isDeferred: this.options.isDeferred
        };
    },
    afterRender: function () {
        if (this.isFetched()) {
            this.renderAttachments();
        }
    },
    sortAttachments: function (attachments) {
        let self = this,
            result = attachments.sort(function (a, b) {
                if (self.options.sortBy === "size") {
                    return a.getSize() > b.getSize() ? 1 : -1;
                } else if (self.options.sortBy === "modifiedOn") {
                    return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('modifiedOn'), b.get('modifiedOn'));
                } else {
                    let aso = a.get('sortOrder'),
                        bso = b.get('sortOrder');
                    return PJQ.helpers.sortHelpers.sortAlphaNum(aso != null ? aso.toString() : a.get('name'), bso != null ? bso.toString() : b.get('name'));
                }
            });
        return this.options.sortDirection === 'desc' ? result.reverse() : result;
    },
    renderAttachments: function () {
        if (this.options.sortBy == null) {
            this.options.sortBy = "name";
        }

        let $container = this.$('.attachments-nav'),
            rootAttachments = _.filter(this.collection.models, function (attachment) {
                return attachment.getParentFolder() == null;
            });

        if (this.options.project == null) {
            rootAttachments = this.sortAttachments(rootAttachments);
        } else {
            rootAttachments = _.sortBy(rootAttachments, function (attachment) {
                switch (attachment.get('name').toLowerCase()) {
                    case 'drawings':
                        return 1;
                    case 'shared':
                        return 2;
                    case 'attachments':
                        return 3;
                    case 'private':
                        return 4;
                    case 'mall':
                        return 5;
                    default:
                        return 0;
                }
            });
        }

        let self = this;
        $container.find('.attachment-folder.expanded').each(function () {
            let cid = $(this).data('cid');
            if (self.expandedFolders.indexOf(cid)) {
                self.expandedFolders.push(cid);
            }
        });
        if (_.size(rootAttachments) > 0) {
            $container.empty();
            //render folders first
            _.each(_.filter(rootAttachments, function (attachment) {
                return attachment.get('isFolder');
            }), function (attachment) {
                this.renderAttachment($container, attachment);
            }, this);
            //render files last
            _.each(_.filter(rootAttachments, function (attachment) {
                return !attachment.get('isFolder');
            }), function (attachment) {
                this.renderAttachment($container, attachment);
            }, this);
            this.initContextMenu();
        }
    },
    renderAttachment: function ($container, attachment, depth = 0) {
        let folderAttachments = this.sortAttachments(attachment.getFolderAttachments());
        this.renderSubTemplate(true, this.options.subTemplates.file, $container, {
            model: attachment,
            isDeferred: this.options.isDeferred,
            options: this.options,
            isAdmin: this.options.isAdmin,
            canAdd: this.options.canAdd,
            isSelected: this.selectedAttachmentIds.indexOf(attachment.cid) !== -1,
            isExpanded: this.expandedFolders.indexOf(attachment.cid) !== -1,
            depth: depth
        }, _.bind(function ($folder) {
            if (attachment.get('isFolder')) {
                depth++;
                let $files = $folder.find('.attachment-files').first();
                _.each(_.filter(folderAttachments, function (attachment) {
                    return attachment.get('isFolder');
                }), function (folderAttachment) {
                    this.renderAttachment($files, folderAttachment, depth);
                }, this);

                _.each(_.filter(folderAttachments, function (attachment) {
                    return !attachment.get('isFolder');
                }), function (folderAttachment) {
                    this.renderAttachment($files, folderAttachment, depth);
                }, this);
            }
        }, this));
    },
    renderContextMenu: function (e) {
        let $target = $(e.currentTarget),
            $menu = $target.closest('.btn-group').find('.dropdown-menu'),
            $attachment = $target.closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid')),
            depth = parseInt($attachment.data('depth'));
        this.renderSubTemplate(true, this.options.subTemplates.fileMenu, $menu, {
            model: attachment,
            depth: depth,
            clipboard: this.clipboard,
            foldersOnly: this.options.foldersOnly,
            canShare: this.options.canShare,
            isAdmin: this.options.isAdmin,
            canAdd: this.options.canAdd,
        });
    },
    initContextMenu: function () {
        let $container = this.$('.attachments-nav');
        new PJQ.menus.ContextMenu({
            el: $container,
            selector: '.attachment',
            actions: this.getMenuActions(),
            fetchElementData: _.bind(function (element) {
                return this.collection.get($(element).data('cid'));
            }, this),
            onOpen: _.bind(function (attachment) {
                this.getAttachmentElement(attachment).addClass('context-attachment');
            }, this),
            onClose: _.bind(function () {
                this.$('.context-attachment').removeClass('context-attachment');
            }, this)
        });
    },
    changeSort: function (e) {
        let $target = $(e.currentTarget),
            newSort = $target.data('attr');
        if (newSort !== this.options.sortBy || this.options.sortDirection === 'desc') {
            this.options.sortDirection = 'asc';
        } else {
            this.options.sortDirection = 'desc';
        }
        this.options.sortBy = newSort;

        this.$('.fa-long-arrow-up,.fa-long-arrow-down').removeClass('active');
        if (this.options.sortDirection === 'asc') {
            $target.parent('div').find('.fa-long-arrow-down').addClass('active');
        } else {
            $target.parent('div').find('.fa-long-arrow-up').addClass('active');
        }

        this.renderAttachments();
    },
    getAttachmentElement: function (attachment) {
        let $aNav = this.$('.attachments-nav');
        if (attachment.cid === -1) {
            return $aNav;
        }
        return $aNav.find('.attachment[data-cid="' + attachment.cid + '"]');
    },
    attachmentLinkClicked: function (e) {
        e.stopPropagation();

        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.get('isFolder')) {
            this.expandFolder($attachment);
        } else {
            if (this.options.project != null && this.options.project.orderSettings != null && this.options.project.orderSettings.get('downloadPerFileFee') > 0) {
                new PJQ.views.files.FileViewer({
                    model: attachment,
                    isDisableDownload: true
                });
            } else if (this.options.orderSettings != null && this.options.orderSettings.downloadPerFileFee > 0) {
                new PJQ.views.files.FileViewer({
                    model: attachment,
                    isDisableDownload: true
                });
            } else if (attachment.get('name').toLowerCase().endsWith('.pdf') && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.FILE_NAVIGATOR_VIEW_ON_CLICK)) {
                new PJQ.views.files.FileViewer({
                    model: attachment
                });
            } else {
                this.downloadAttachments(attachment);
            }
        }
    },
    attachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.get('isFolder')) {
            this.expandFolder($attachment);
        }
    },
    attachmentDblClicked: function (e) {
        let $attachment = $(e.currentTarget),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.get('isFolder')) {
            this.expandFolder($attachment);
        } else {
            if (this.options.project != null && this.options.project.orderSettings != null && this.options.project.orderSettings.get('downloadPerFileFee') > 0) {
                new PJQ.views.files.FileViewer({
                    model: attachment,
                    isDisableDownload: true
                });
            } else if (this.options.orderSettings != null && this.options.orderSettings.downloadPerFileFee > 0) {
                new PJQ.views.files.FileViewer({
                    model: attachment,
                    isDisableDownload: true
                });
            } else if (attachment.get('name').toLowerCase().endsWith('.pdf') && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.FILE_NAVIGATOR_VIEW_ON_CLICK)) {
                new PJQ.views.files.FileViewer({
                    model: attachment
                });
            } else {
                this.downloadAttachments(attachment);
            }
        }
    },
    attachmentChecked: function (e) {
        let $checkbox = $(e.currentTarget),
            $attachment = $checkbox.closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid')),
            isChecked = $(e.currentTarget).prop('checked'),
            attachmentIds = [attachment.cid];

        if (attachment.get('isFolder')) {
            attachmentIds.push(..._.map(attachment.getFolderAttachments(true), function (folderAttachment) {
                return folderAttachment.cid;
            }));
            $attachment.siblings('.attachment-files-outer').find('.input-select-attachment').prop('checked', isChecked);
        }

        if (isChecked) {
            this.addSelectedAttachmentIds(attachmentIds);
        } else {
            let parent = attachment.getParentFolder();
            if (parent != null) {
                this.getAttachmentElement(parent).find('.input-select-attachment').prop('checked', false);
                attachmentIds.push(parent.cid);
            }
            this.$('.input-select-all').prop('checked', false);

            this.removeSelectedAttachmentIds(attachmentIds);
        }
    },
    addSelectedAttachmentIds: function (attachmentIds) {
        this.selectedAttachmentIds = _.union(this.selectedAttachmentIds, attachmentIds)
        this.selectedAttachmentsChanged();
    },
    removeSelectedAttachmentIds: function (attachmentIds) {
        this.selectedAttachmentIds = _.difference(this.selectedAttachmentIds, attachmentIds);
        this.selectedAttachmentsChanged();
    },
    selectedAttachmentsChanged: function () {
        let selectedCount = _.size(this.selectedAttachmentIds);
        this.$('.btn-download-selected,.btn-file-actions,.btn-order-selected,.btn-share-selected').prop('disabled', selectedCount === 0);

        if (!this.options.isDeferred) {
            this.$('.ct-selected-attachments').html(selectedCount);
        }

        let selectedAttachments = this.collection.get(this.selectedAttachmentIds);
        let hasDrawings = _.find(selectedAttachments, function (attachment) {
            return attachment.get('isDrawing');
        }) != null;
        if (hasDrawings) {
            this.$('.btn-add-selected-to-drawings,.btn-cut-selected,.btn-copy-selected,.btn-delete-selected').addClass('hidden');
        } else {
            this.$('.btn-add-selected-to-drawings,.btn-delete-selected').removeClass('hidden');

            let hasRootFolder = _.find(selectedAttachments, function (attachment) {
                return attachment.get('folderId') === -1 || !(attachment.get('entryId') > 0);
            }) != null;
            if (hasRootFolder) {
                this.$('.btn-cut-selected,.btn-copy-selected').addClass('hidden');
            } else {
                this.$('.btn-cut-selected,.btn-copy-selected').removeClass('hidden');
            }
        }
    },
    expandFolder: function ($folder, expandOnly = false) {
        let $attachments = $folder.siblings('.attachment-files-outer'),
            isExpanded = $attachments.is(':visible'),
            fnExpand = _.bind(function () {
                if (!isExpanded) {
                    $folder.addClass('expanded');
                    $attachments.animateCSS('slideDown');
                } else if (!expandOnly) {
                    $attachments.animateCSS('slideUp', function () {
                        $folder.css({
                            background: ''
                        });
                    });
                    $folder.removeClass('expanded');
                }
            }, this);
        let folder = this.collection.get($folder.data('cid'));
        if (this.options.isDeferred && !isExpanded && folder.get('entryId') > 0) {
            let fnRender = _.bind(function () {
                if (!$attachments.hasClass('fetched')) {
                    $attachments.addClass('fetched');
                    let $files = $attachments.find('.attachment-files').first(),
                        folderAttachments = folder.getFolderAttachments();
                    $files.empty();
                    _.each(this.sortAttachments(_.filter(folderAttachments, function (attachment) {
                        return attachment.get('isFolder');
                    })), _.bind(function (attachment) {
                        this.renderAttachment($files, attachment, attachment.getDepth());
                    }, this));

                    _.each(this.sortAttachments(_.filter(folderAttachments, function (attachment) {
                        return !attachment.get('isFolder');
                    })), _.bind(function (attachment) {
                        this.renderAttachment($files, attachment, attachment.getDepth());
                    }, this));
                }
                fnExpand();
            }, this);
            if (folder.isFetched) {
                fnRender();
            } else {
                folder.fetchFolderAttachments(null, _.bind(function (files) {
                    if ((this.selectedAttachments != null && this.selectedAttachments.get(folder.cid) != null) || this.selectedAttachmentIds.indexOf(folder.cid) !== -1) {
                        _.each(files, _.bind(function (file) {
                            if (this.selectedAttachments != null) {
                                this.selectedAttachments.add(file);
                            } else {
                                if (this.selectedAttachmentIds.indexOf(file.cid) === -1) {
                                    this.selectedAttachmentIds.push(file.cid)
                                }
                            }
                        }, this));
                    }
                    fnRender();
                }, this));
            }
        } else {
            fnExpand();
        }
    },
    addRootFolderClicked: function () {
        new PJQ.views.files.NewFolderModal({
            folder: new PJQ.models.files.File({
                entryId: -1,
                isFolder: true
            }),
            project: this.options.project,
            onSave: _.bind(function (newFolder) {
                this.collection.add(newFolder);
            }, this)
        });
    },
    addFolderClicked: function (e) {
        let $folder = $(e.currentTarget).closest('.attachment'),
            folder = this.collection.get($folder.data('cid'));
        this.addFolder(folder);
    },
    addFolder: function (folder) {
        new PJQ.views.files.NewFolderModal({
            folder: folder,
            project: this.options.project,
            onSave: _.bind(function (newFolder) {
                this.collection.add(newFolder);
            }, this)
        });
    },
    uploadRootAttachmentsClicked: function () {
        this.uploadToFolder(new PJQ.models.files.File({
            entryId: -1,
            isFolder: true
        }));
    },
    uploadToFolderClicked: function (e) {
        let $folder = $(e.currentTarget).closest('.attachment'),
            folder = this.collection.get($folder.data('cid'));
        this.uploadToFolder(folder);
    },
    uploadToFolder: function (folder) {
        if (!folder.get('isFolder')) {
            return;
        }

        new PJQ.views.files.FileUploaderModal({
            project: this.options.project,
            folder: folder,
            onDone: _.bind(function (files) {
                let successFiles = [];
                _.each(files, function (file) {
                    if (file.get('status') !== 'success' && !file.get('isFolder')) {
                        return;
                    }

                    file.collection = null;
                    if (null == _.find(files, function (fi) {
                        return file.get('folderId') === fi.get('entryId');
                    })) {
                        file.set('folderId', folder.get('entryId'));
                    }
                    successFiles.push(file);
                });
                if (folder.get('entryId') === -1 || folder.isFetched || !this.options.isDeferred) {
                    this.collection.add(successFiles);
                }
                if (folder.get('entryId') > 0) {
                    this.expandFolder(this.getAttachmentElement(folder), true);
                }
            }, this)
        });
    },
    shareAttachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        this.shareAttachments(attachment);
    },
    shareSelected: function () {
        this.shareAttachments(this.collection.get(this.selectedAttachmentIds));
    },
    shareAttachments: function (attachment) {
        let shareAtt = [],
            fnCheck = function (att) {
                if (att.get('entryId') === -1) {
                    shareAtt.push(...att.getFolderAttachments());
                } else {
                    shareAtt.push(att);
                }
            };
        if (PJQ.helpers.objectHelpers.refinedType(attachment) === 'array') {
            _.each(attachment, function (att) {
                fnCheck(att);
            });
        } else {
            fnCheck(attachment);
        }
        let files = new PJQ.collections.files.Files(shareAtt),
            sharingModal = new PJQ.views.sharing.SharingModal({
                onSave: _.bind(function (data) {
                    files.share(data, null, _.bind(function (share) {
                        PJQ.notifications.notify.successNotify({
                            message: 'File share email sent'
                        });
                    }, this));
                }, this)
            });
        files.share(null, null, function (share) {
            let callback = _.bind(sharingModal.urlChanged, sharingModal);
            callback(share.url);
        });
    },
    downloadAttachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        this.downloadAttachments(attachment);
    },
    downloadSelected: function () {
        this.downloadAttachments(this.collection.get(this.selectedAttachmentIds));
    },
    downloadAll: function () {
        this.downloadAttachments(this.collection.models);
    },
    replaceVersionFolders: function (attachments) {
        let isArray = PJQ.helpers.objectHelpers.refinedType(attachments) === 'array';
        if (isArray || (attachments.get('isFolder') && attachments.get('isDrawing'))) {
            let versionFolders = isArray ? _.filter(attachments, function (attachment) {
                return attachment.get('isFolder') && attachment.get('isDrawing');
            }) : [attachments];
            if (_.size(versionFolders) > 0) {
                if (!isArray) {
                    attachments = [];
                }
                _.each(versionFolders, function (versionFolder) {
                    let versionDrawings = this.collection.getFolderAttachments(versionFolder, true);
                    attachments.push(...versionDrawings);
                }, this);

                attachments = attachments.filter(function (attachment) {
                    return !attachment.get('isDrawing') || (!attachment.get('isFolder') && attachment.get('isDrawing'));
                });
            }
        }
        return attachments;
    },
    downloadAttachments: function (attachments, options) {
        attachments = this.replaceVersionFolders(attachments);

        let objType = PJQ.helpers.objectHelpers.refinedType(attachments),
            hasDrawings;
        if (objType === 'array') {
            hasDrawings = _.find(attachments, function (attachment) {
                return attachment.id < -1 && !attachment.get('isFolder');
            }) != null;
            attachments = _.uniq(attachments);
        } else if (objType === 'backboneCollection') {
            hasDrawings = _.find(attachments.models, function (attachment) {
                return attachment.id < -1 && !attachment.get('isFolder');
            }) != null;
            attachments = _.uniq(attachments);
        } else {
            hasDrawings = attachments.id < -1 && !attachments.get('isFolder');
        }

        if (this.options.project != null && (this.options.forShare !== true || hasDrawings)) {
            if (this.options.project.orderSettings == null && this.options.orderSettings != null)
                this.options.project.orderSettings = PJQ.helpers.objectHelpers.refinedType(this.options.orderSettings, true) === 'backboneModel' ? this.options.orderSettings : new PJQ.models.BaseModel(this.options.orderSettings);

            this.options.project.checkDownloadRequirements(_.bind(function () {
                if (!options)
                    options = {project: this.options.project};

                if (!options.project)
                    options.project = this.options.project;

                this.options.project.downloadAttachments(attachments, options);
            }, this));
        } else if (this.options.orderSettings != null && this.options.orderSettings.downloadPerFileFee > 0 && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
            let ids = [],
                entryIds = [],
                objType = PJQ.helpers.objectHelpers.refinedType(attachments, true),
                fnCheck = function (att) {
                    if (att.get('entryId') === -1) {
                        ids.push(..._.map(att.getFolderAttachments(), function (folderAtt) {
                            return folderAtt.id;
                        }));

                        _.each(att.getFolderAttachments(), function (folderAtt) {
                            if (!folderAtt.get('isFolder')) {
                                entryIds.push(folderAtt.get('isDrawing') ? folderAtt.get('drawingId') * -1 : folderAtt.get('entryId'));
                            }
                        });
                    } else {
                        ids.push(att.id);

                        if (!att.get('isFolder')) {
                            entryIds.push(att.get('isDrawing') ? att.get('drawingId') * -1 : att.get('entryId'));
                        }

                    }
                };
            if (objType === 'backboneCollection') {
                _.each(attachments.models, function (attachment) {
                    fnCheck(attachment);
                });
                attachments = _.uniq(attachments);
            } else if (objType === 'array') {
                _.each(attachments, function (attachment) {
                    fnCheck(attachment);
                });
                attachments = _.uniq(attachments);
            } else {
                fnCheck(attachments);
            }

            if (this.options.project != null && this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                new PJQ.views.drawings.OrderDownloadAdmin({
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                new PJQ.views.files.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.DOWNLOAD,
                    files: attachments,
                    orderSettings: this.options.orderSettings,
                    collection: (this.options.project == null && this.options.collection != null) ? this.options.collection : null,
                    project: PJQ.app.session.project != null ? PJQ.app.session.project : this.options.project
                });
            }
        } else {
            if (objType === 'backboneCollection' || objType === 'array' || attachments.get('isFolder')) {
                new PJQ.collections.files.Files(attachments).download();
            } else {
                attachments.download();
            }
        }
    },
    copyAttachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment');
        this.copyAttachments($attachment.data('cid'));
    },
    copySelected: function () {
        this.copyAttachments(this.selectedAttachmentIds);
    },
    copyAttachments: function (attachments) {
        this.clipboard = {
            copy: PJQ.helpers.objectHelpers.refinedType(attachments) === 'array' ? attachments : [attachments]
        };
    },
    cutAttachmentClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment');
        this.cutAttachments($attachment.data('cid'));
    },
    cutSelected: function () {
        this.cutAttachments(this.selectedAttachmentIds);
    },
    cutAttachments: function (attachments) {
        this.clipboard = {
            cut: PJQ.helpers.objectHelpers.refinedType(attachments) === 'array' ? attachments : [attachments]
        };
    },
    pasteClicked: function (e) {
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        this.paste(attachment);
    },
    paste: function (destinationAttachment) {
        let isCopy = _.size(this.clipboard.copy) > 0,
            fileCount = isCopy ? _.size(this.clipboard.copy) : _.size(this.clipboard.cut),
            pasteFunc = _.bind(function () {
                if (isCopy) {
                    destinationAttachment.copy(this.collection.get(this.clipboard.copy), {
                        project: this.options.project
                    }, _.bind(function (newAttachments) {
                        if (_.size(newAttachments) > 0) {
                            this.collection.add(newAttachments);
                        }
                    }, this));
                } else {
                    destinationAttachment.move(this.collection.get(this.clipboard.cut), {
                        project: this.options.project
                    }, _.bind(function () {
                        this.renderAttachments();
                    }, this));
                }
                this.clipboard = null;
                this.selectedAttachmentIds = [];
            }, this);

        if (destinationAttachment.get('entryId') > 0) {
            pasteFunc();
        } else {
            new PJQ.views.modals.YesNo({
                header: (isCopy ? "Copy" : "Move") + " File" + (fileCount > 1 ? "s" : ""),
                body: "You are " + (isCopy ? "copying" : "moving") + (fileCount > 1 ? " these files" : " this file") + " to the shared folder root, which will put them in the root of your document center.  Are you sure you want to do this?",
                onYes: function () {
                    pasteFunc();
                }
            });
        }
    },
    renameAttachmentClicked: function (e) {
        let cid = $(e.currentTarget).closest('.attachment').data('cid');
        this.renameAttachment(this.collection.get(cid));
    },
    renameAttachment: function (attachment) {
        new PJQ.views.files.RenameFileModal({
            model: attachment,
            onSave: _.bind(function () {
                this.renderAttachments();
            }, this)
        });
    },
    deleteAttachmentClicked: function (e) {
        let cid = $(e.currentTarget).closest('.attachment').data('cid');
        this.deleteAttachments([this.collection.get(cid)]);
    },
    deleteSelected: function () {
        this.deleteAttachments(this.collection.get(this.selectedAttachmentIds));
    },
    deleteAttachments: function (attachments) {
        let text,
            title = "Confirm Deletion",
            btnText = "Delete",
            isArray = PJQ.helpers.objectHelpers.refinedType(attachments) === 'array',
            isDetach = false;
        if (!isArray && attachments.get('isFolder')) {
            if (attachments.get('folderId') === -1) {
                title = "Detach Folder";
                text = "Are you sure you want to detach this folder from the project?  It will not be deleted from your document center.";
                btnText = "Detach";
                isDetach = true;
            } else {
                text = "Are you sure you want to delete this folder?";
            }
        } else if (_.size(attachments) > 1) {
            text = "Are you sure you want to delete these files?";
        } else {
            text = "Are you sure you want to delete this file?";
        }
        new PJQ.views.modals.DeleteCancel({
            header: title,
            body: text,
            deleteButtonText: btnText,
            onDelete: _.bind(function () {
                let privateFolder = _.find(this.collection.models, function(model) { return model.get('entryId') > 0 && model.get('folderId') === 0; }),
                    privateFolderId = privateFolder ? privateFolder.get('entryId') : null,
                    fnCallback = _.bind(function () {
                    _.each(isArray ? attachments : [attachments], function (attachment) {
                        if (attachment.get('isFolder')) {
                            _.each(this.collection.getFolderAttachments(attachment, true), function (folderAttachment) {
                                this.collection.remove(folderAttachment);
                            }, this);
                        }
                        if (attachment.get('entryId') !== privateFolderId)
                            this.collection.remove(attachment);
                        else {
                            this.removeSelectedAttachmentIds([privateFolderId]);
                            this.$('.attachment-folder[data-cid="' + attachment.cid + '"').find('.input-select-attachment').prop('checked', false);
                        }
                    }, this);
                }, this);
                if (isDetach) {
                    //if it gets here, attachments is a single object, not an array
                    attachments.detachFromProject(this.options.project, function () {
                        fnCallback();
                    });
                } else if (!isArray) {
                    attachments.destroy();
                    fnCallback();
                } else {
                    let col = new PJQ.collections.files.Files(attachments);
                    col.destroy(_.bind(function () {
                        fnCallback();
                    }, this));
                }
            }, this)
        });
    },
    attachmentDragStart: function (e) {
        this.draggedAttachment = this.collection.get($(e.target).data('cid'));
    },
    attachmentDragOver: function (e) {
        e.preventDefault();
    },
    attachmentDragEnter: function (e) {
        this.$('.drag-hover').removeClass('drag-hover');
        let $target = $(e.target).closest('.attachment-outer');
        if (_.size($target) > 0) {
            let $attachment = $target.find('.attachment').first(),
                targetAttachment = this.collection.get($attachment.data('cid'));
            if ($attachment.hasClass('attachment-folder') && this.draggedAttachment.cid !== targetAttachment.cid &&
                this.draggedAttachment.get('folderId') !== targetAttachment.get('entryId')) {
                this.lastDragOverAttachment = targetAttachment;
                $target.addClass('drag-hover');
            }
        }
    },
    attachmentDragLeave: function (e) {
        let $target = $(e.target).closest('.attachment-outer'),
            $attachment = $target.find('.attachment');
        if (_.size($target) > 0) {
            if ($attachment.hasClass('attachment-folder')) {
                let targetCid = $attachment.first().data('cid');
                if (this.lastDragOverAttachment == null || targetCid !== this.lastDragOverAttachment.cid) {
                    $target.removeClass('drag-hover');
                }
            }
        }
    },
    attachmentDrop: function (e) {
        let $target = $(e.target).closest('.attachment-outer'),
            $attachment = $target.find('.attachment').first(),
            destinationAttachment = this.collection.get($attachment.data('cid'));
        if (this.draggedAttachment != null && destinationAttachment != null && destinationAttachment.get('isFolder') &&
            destinationAttachment.get('entryId') !== this.draggedAttachment.get('entryId') &&
            destinationAttachment.get('entryId') !== this.draggedAttachment.get('folderId') &&
            destinationAttachment.get('folderId') !== this.draggedAttachment.get('entryId')) {
            destinationAttachment.move([this.draggedAttachment], {
                project: this.options.project
            }, _.bind(function () {
                this.renderAttachments();
            }, this));
            this.draggedAttachment = null;
        }
    },
    orderSelected: function () {
        let callback = _.bind(function () {
            let selectedAttachments = this.collection.get(this.selectedAttachmentIds),
                fnOrder = _.bind(function () {
                    let orderAtt = [];
                    _.each(selectedAttachments, function (selectedAttachment) {
                        if (selectedAttachment.get('isFolder')) {
                            orderAtt.push(...selectedAttachment.getFolderAttachments(true));
                        } else {
                            orderAtt.push(selectedAttachment);
                        }
                    });
                    this.order(orderAtt);
                }, this);
            if (this.options.isDeferred) {
                this.collection.fetchFoldersAttachments(selectedAttachments, {recursive: true}, _.bind(function () {
                    fnOrder();
                }, this));
            } else {
                fnOrder();
            }
        }, this);

        if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
            new PJQ.views.modals.YesNo({
                header: "Document(s) Processing",
                body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
                onYes: _.bind(function () {
                    callback();
                }, this)
            });
        } else
            callback();
    },
    orderAttachmentClicked: function (e) {
        let callback = _.bind(function () {
            let cid = $(e.currentTarget).closest('.attachment').data('cid');
            this.order(this.collection.get(cid));
        }, this);

        if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
            new PJQ.views.modals.YesNo({
                header: "Document(s) Processing",
                body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
                onYes: _.bind(function () {
                    callback();
                }, this)
            });
        } else
            callback();

    },
    exportFileListClicked: function (e) {
        let cid = $(e.currentTarget).closest('.attachment').data('cid');
        this.exportFileList(this.collection.get(cid));
    },
    exportFileList: function (attachment) {
        attachment.exportFileList();
    },
    attachmentPropertiesClicked: function (e) {
        let cid = $(e.currentTarget).closest('.attachment').data('cid');
        this.attachmentProperties(this.collection.get(cid));
    },
    attachmentProperties: function (attachment) {
        attachment.fetchFolderAttachments({recursive: true}, _.bind(function () {
            new PJQ.views.files.FilePropertiesModal({
                model: attachment,
                project: this.options.project
            });
        }, this));
    },
    order: function (attachments) {
        if (PJQ.helpers.objectHelpers.refinedType(attachments) === 'object') {
            attachments = [attachments];
        }

        let self = this;
        let fnOrder = function () {
            let orderAttachments = [];
            _.each(attachments, function (attachment) {
                if (attachment.get('isFolder')) {
                    orderAttachments.push(...attachment.getFolderAttachments(true, {hideFolders: true}));
                } else {
                    orderAttachments.push(attachment);
                }
            });
            new PJQ.views.files.OrderPrintsModal({
                files: _.uniq(orderAttachments),
                collection: (self.options.project == null && self.options.collection != null) ? self.options.collection : null
            });
        };
        if (this.options.isDeferred && _.find(attachments, function (a) {
            return a.get('isFolder') && !a.isFetched;
        }) != null) {
            this.collection.fetchFoldersAttachments(attachments, {recursive: true}, function () {
                fnOrder();
            });
        } else {
            fnOrder();
        }
    }
});

PJQ.views.files.RenameFileModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-Rename-File'),
        width: '500px'
    },
    events: {
        'keyup .input-name': 'nameChanged',
        'click .btn-save': 'save'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {
        this.$('.input-name').focus();
    },
    nameChanged: function (e) {
        if (e.keyCode === 13) {
            this.save();
        }
    },
    save: function () {
        let newName = this.$('.input-name').val();
        if (!this.model.get('isFolder')) {
            newName += this.model.getExtension();
        }

        if (newName !== this.model.get('name')) {
            this.model.save({
                name: newName
            }, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.files.NewFolderModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-New-Folder'),
        width: '500px'
    },
    events: {
        'keyup .input-name': 'folderNameChanged',
        'click .btn-add': 'save'
    },
    beforeRender: function () {
        this.model = new PJQ.models.files.File({
            isFolder: true,
            folderGuid: this.options.folder.get('guid'),
            name: ""
        });
        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {
        this.$('.input-name').focus();
    },
    folderNameChanged: function (e) {
        if (e.keyCode === 13) {
            this.save();
        }
    },
    save: function () {
        let $folderName = this.$('.input-name'),
            folderName = this.$('.input-name').val(),
            folderNameValid = _.size(folderName) > 0;
        PJQ.helpers.inputHelpers.setInputError($folderName, folderNameValid);
        if (!folderNameValid) {
            return;
        }

        let urlOptions;
        if (this.options.project != null) {
            urlOptions = {
                params: [
                    {
                        parameter: 'projectId',
                        value: this.options.project.id
                    }
                ]
            }
        } else {
            urlOptions = null;
        }

        this.model.save({
            name: folderName
        }, {
            urlOptions: urlOptions,
            success: _.bind(function () {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});
